
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.702 6.807L7.106 1.3A1 1 0 017.82 1H12a1 1 0 011 1v4.07a1 1 0 01-.286.7l-5.415 5.517a1 1 0 01-1.413.015l-4.17-4.08a1 1 0 01-.014-1.415z","stroke":"#8F7A61","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"9.5","cy":"4.5","r":".75","stroke":"#8F7A61","stroke-width":"1.5"}})])
          )
        }
      }
    